import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";
import type { StepProps } from "./step.types";

export default function VisaEligibility({ answers }: StepProps) {
  const { t } = useTranslation();
  const { serviceType } = answers;
  const choices =
    serviceType === "Student visa"
      ? [
          {
            label: t("FUNNEL_STUDENT_VISA_ELIGIBILITY_CHOICE_ACCEPTED_SCHOOL"),
            value: "I’ve been accepted to school in the U.S.",
          },
          {
            label: t("FUNNEL_STUDENT_VISA_ELIGIBILITY_CHOICE_APPLIED_SCHOOL"),
            value: "I’m waiting for a decision on my application",
          },
          {
            label: t(
              "FUNNEL_STUDENT_VISA_ELIGIBILITY_CHOICE_NOT_APPLIED_SCHOOL",
            ),
            value: "I haven’t applied yet",
          },
        ]
      : serviceType === "Investor visa"
        ? [
            {
              label: t(
                "FUNNEL_INVESTOR_VISA_ELIGIBILITY_CHOICE_HAS_INVESTMENT",
              ),
              value: "I have an investment in the U.S.",
            },
            {
              label: t(
                "FUNNEL_INVESTOR_VISA_ELIGIBILITY_CHOICE_CONSIDERING_INVESTMENT",
              ),
              value: "I’m considering a few investment options",
            },
            {
              label: t("FUNNEL_INVESTOR_VISA_ELIGIBILITY_CHOICE_NO_INVESTMENT"),
              value: "I don’t have any investments lined up yet",
            },
          ]
        : serviceType === "Employment visa"
          ? [
              {
                label: t(
                  "FUNNEL_EMPLOYMENT_VISA_ELIGIBILITY_CHOICE_HAS_JOB_OFFER",
                ),
                value: "I have a job offer from a U.S. employer",
              },
              {
                label: t(
                  "FUNNEL_EMPLOYMENT_VISA_ELIGIBILITY_CHOICE_APPLIED_JOBS",
                ),
                value: "I’ve applied and am still awaiting a job offer",
              },
              {
                label: t(
                  "FUNNEL_EMPLOYMENT_VISA_ELIGIBILITY_CHOICE_NOT_APPLIED_JOBS",
                ),
                value: "I haven’t applied yet",
              },
            ]
          : [];

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_VISA_ELIGIBILITY_TITLE")}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.visaEligibility}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
